import moment from 'moment';
import React from 'react';
import {
  DateCellRenderer,
  createTextRenderer,
  createBoldTextRenderer,
  createStatusPillRenderer,
  styledDefaultColDef,
} from '../../../extras/cellRenderers';

const VerifiedStatusRenderer = createStatusPillRenderer({
  true: { bg: '#ECFDF5', color: '#059669', border: '#A7F3D0', label: 'Verified' },
  false: { bg: '#FEF2F2', color: '#DC2626', border: '#FECACA', label: 'Unverified' },
});

function VerifiedGetter(params) {
  return <VerifiedStatusRenderer value={params.data?.verified} />;
}

export const columnDefs = [
  { field: 'id', hide: true },
  {
    headerName: 'Company Name',
    field: 'name',
    width: 250,
    cellRenderer: createBoldTextRenderer((p) => p.data?.name),
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['contains'],
      debounceMs: 200,
    },
  },
  {
    headerName: 'Website',
    field: 'website',
    cellRenderer: createTextRenderer((p) => p.data?.website),
    filter: 'agTextColumnFilter',
    width: 300,
    filterParams: {
      filterOptions: ['contains'],
      debounceMs: 200,
    },
  },
  {
    headerName: 'Tags',
    field: 'tags',
    cellRenderer: createTextRenderer((p) => p.data?.tags?.join(', ') || '— No Tags —'),
  },
  {
    headerName: 'Verified',
    field: 'verified',
    cellRenderer: VerifiedGetter,
  },
  {
    headerName: 'Updated At',
    field: 'updatedAt',
    cellRenderer: DateCellRenderer,
    filter: 'agDateColumnFilter',
    width: 200,
    filterParams: {
      debounceMs: 200,
      comparator: (filterLocalDateAtMidnight, cellValue) => {
        const filter = moment(filterLocalDateAtMidnight);
        const dateAsString = moment(cellValue).format('DD/MM/YYYY');
        if (dateAsString == null) {
          return 0;
        }
        const dateParts = dateAsString.split('/');
        const year = Number(dateParts[2]);
        const month = Number(dateParts[1]) - 1;
        const day = Number(dateParts[0]);
        const cellDate = new Date(year, month, day);

        if (moment(cellDate) < filter) {
          return -1;
        } else if (moment(cellDate) > filter) {
          return 1;
        }
        return 0;
      },
    },
  },
  {
    headerName: 'Updated By',
    width: 300,
    field: 'status',
    cellRenderer: createTextRenderer((p) => p.data?.updatedBy || '—'),
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      const nameA = nodeA.data?.updatedBy;
      const nameB = nodeB.data?.updatedBy;
      const comparison = nameA?.localeCompare(nameB) || 0;
      return comparison;
    },
  },
  {
    headerName: 'Actions',
    field: 'actions',
    cellRenderer: 'btnCellRenderer',
    pinned: 'right',
    width: 300,
    sortable: false,
    suppressMenu: true,
  },
];

export const defaultColDef = {
  ...styledDefaultColDef,
  filter: true,
};
